export enum MediaObjectType {
    Document = 1,
    Image = 2,
}